var _path, _path2, _path3, _path4, _rect, _circle, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 156,
    viewBox: "0 0 443 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_589_3734",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 7,
    width: 367,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.424 78.625C294.749 78.625 294.34 78.5 294.198 78.25C294.091 78 294.037 77.3958 294.037 76.4375V11.9375C294.037 10.7292 294.109 9.9375 294.25 9.5625C294.393 9.1875 294.98 9 296.011 9H344.708C345.74 9 346.646 9.0625 347.429 9.1875C348.246 9.3125 348.655 9.97917 348.655 11.1875C348.655 12.2292 348.246 12.8125 347.429 12.9375C346.646 13.0625 345.74 13.125 344.708 13.125H298.571V40.5H344.442C345.224 40.5 345.881 40.625 346.415 40.875C346.948 41.125 347.215 41.6667 347.215 42.5C347.215 43.4167 346.984 44.0208 346.521 44.3125C346.095 44.6042 345.526 44.75 344.815 44.75H298.571V74.5H344.815C345.846 74.5 346.753 74.5625 347.535 74.6875C348.353 74.8125 348.762 75.3958 348.762 76.4375C348.762 77.6458 348.424 78.3125 347.749 78.4375C347.109 78.5208 346.273 78.5833 345.241 78.625H295.424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.005 78.625C206.974 78.625 206.316 78.2083 206.032 77.375C205.783 76.5 205.658 75.4583 205.658 74.25V13.0625C205.658 10.4792 206.387 9.1875 207.845 9.1875C208.734 9.1875 209.766 9.8125 210.939 11.0625L265.503 70.625V13.75C265.503 12.5417 265.61 11.4583 265.823 10.5C266.072 9.5 266.73 9 267.797 9C268.721 9 269.325 9.47917 269.611 10.4375C269.895 11.3542 270.037 12.4583 270.037 13.75V74.625C270.037 77.2917 269.432 78.625 268.224 78.625C267.405 78.625 266.392 77.9792 265.183 76.6875L210.192 17V74.25C210.192 75.4583 210.032 76.5 209.712 77.375C209.428 78.2083 208.858 78.625 208.005 78.625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.935 79.9375C135.307 79.9375 126.596 77.1458 120.8 71.5625C115.003 65.9792 112.105 56.6667 112.105 43.625V13.375C112.105 12.2917 112.248 11.2917 112.532 10.375C112.817 9.45833 113.474 9 114.506 9C115.395 9 115.964 9.45833 116.212 10.375C116.497 11.2917 116.639 12.2917 116.639 13.375V43.625C116.639 50.875 117.546 56.8958 119.359 61.6875C121.173 66.4375 124.284 69.9792 128.693 72.3125C133.103 74.6458 139.184 75.8125 146.935 75.8125C154.686 75.8125 160.75 74.6458 165.124 72.3125C169.532 69.9792 172.626 66.4375 174.404 61.6875C176.218 56.8958 177.124 50.875 177.124 43.625V13.375C177.124 12.2917 177.267 11.2917 177.551 10.375C177.835 9.45833 178.422 9 179.311 9C180.342 9 180.982 9.45833 181.232 10.375C181.516 11.2917 181.658 12.2917 181.658 13.375V43.625C181.658 56.6667 178.778 65.9792 173.018 71.5625C167.257 77.1458 158.563 79.9375 146.935 79.9375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.116 79.875C61.0979 79.875 57.3998 79.4792 54.0218 78.6875C50.6438 77.8958 47.7813 76.4375 45.4344 74.3125C43.1231 72.1875 41.5052 69.1667 40.5807 65.25C40.3673 64.5417 40.3318 63.7083 40.474 62.75C40.6518 61.7917 41.2207 61.3125 42.1808 61.3125C42.6431 61.3125 43.1053 61.5208 43.5676 61.9375C44.0299 62.3125 44.3321 62.875 44.4743 63.625C45.2211 67.4167 46.6967 70.1667 48.9014 71.875C51.1416 73.5417 53.7018 74.5833 56.582 75C59.4978 75.375 62.3425 75.5625 65.116 75.5625C70.1654 75.5625 74.0057 74.2708 76.637 71.6875C79.3039 69.0625 81.1173 65.2292 82.0774 60.1875C83.0731 55.1042 83.5709 48.875 83.5709 41.5V13.375C83.5709 12.1667 83.7131 11.1458 83.9976 10.3125C84.282 9.4375 84.9399 9 85.9711 9C86.8956 9 87.4823 9.47917 87.7312 10.4375C87.9801 11.3958 88.1046 12.375 88.1046 13.375V41.5C88.1046 50.1667 87.4112 57.3333 86.0244 63C84.6732 68.6667 82.3263 72.8958 78.9838 75.6875C75.6769 78.4792 71.0543 79.875 65.116 79.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 396.762,
    y: 31,
    width: 8,
    height: 24,
    rx: 4,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 369.762,
    cy: 43,
    r: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 380.762,
    y: 18,
    width: 8,
    height: 48,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_589_3734)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: -4,
    width: 374,
    height: 92,
    fill: "url(#paint0_linear_589_3734)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_589_3734",
    x1: 34.5,
    y1: 42,
    x2: 408.5,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9D2EF8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#9D2EF8;#F088DD;#9D2EF8",
    dur: "8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F088DD"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#F088DD;#9D2EF8;#F088DD",
    dur: "8s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.afe227b0196719f883e36fc2b49d8ee6.svg";
export { ForwardRef as ReactComponent };